import { render, staticRenderFns } from "./goodsTothirdPartyAdd.vue?vue&type=template&id=21c6d012&scoped=true&"
import script from "./goodsTothirdPartyAdd.vue?vue&type=script&lang=js&"
export * from "./goodsTothirdPartyAdd.vue?vue&type=script&lang=js&"
import style0 from "./goodsTothirdPartyAdd.vue?vue&type=style&index=0&id=21c6d012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6d012",
  null
  
)

export default component.exports